import { css } from 'lit';

export const contributorUpgradeViewStyles = css`

  :host {
    background: linear-gradient(0deg, var(--gray-1) 0%, var(--gray-1) 70%, var(--yellow-2) 100%);

    --q1-view-width: var(--q1-content-width-narrow);
  }

  view-content {
    padding-top: 3rem;
  }
  @media (min-width: 650px) {
    view-content {
      padding-top: 5rem;
    }
  }

  ul {
    padding-left: 1rem;
  }

  button-bar {
    margin: var(--view-item-spacing) 0;
  }

  tag-workflow {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: var(--view-item-spacing) 0;
    padding: 0.7rem 1.1rem;
    column-gap: 0.5rem;
    row-gap: 1rem;
    
    color: var(--gray-6);
    background: var(--gray-0);
    border: 1px solid var(--gray-2);
    border-radius: 3px;

    flex-wrap: wrap;
  }
  tag-workflow .title {
    display: inline-block;
    font-weight: 200;

    flex: 1 1 100%;
  }
  @media (min-width: 650px) {
    tag-workflow {
      justify-content: space-between;
      flex-wrap: nowrap;
    }
    tag-workflow .title {
      flex: 0 0 auto;
    }
  }

  tag-workflow sl-tag[variant=success]::part(base) {
    color: var(--gray-5);
    background-color: transparent;
    border-color: var(--gray-2);
    font-style: italic;
    text-decoration: line-through;
  }
  tag-workflow sl-tag[variant=primary]::part(base) {
    font-weight: 600;
  }

  two-column-container {
    display: flex;
    gap: var(--view-item-spacing);
    flex-wrap: wrap;
  }

  two-column-container > .left,
  two-column-container > .right {
    display: block;
    flex: 1 1 40%;
    min-width: 18rem;
  }

  q1-tutorial-list {
    margin: var(--view-item-spacing) 0;
    padding: 0.5rem;

    background: white;
    border-radius: 7px;
    box-shadow: var(--sl-shadow-x-small);

    --table-th-border-bottom: 1px solid var(--gray-2);
  }

  sl-relative-time {
    display: inline-block;
  }

`;
